import axios from "axios";
import i18next from "i18next";

import importer from "common/importer";
const Config = importer("Config");
const securityKey = Config.CHATBOT_SECRET_KEY;
export const chatbotUrl = Config.CHATBOT_URL;
export const chatbotReq = axios.create({
  baseURL: chatbotUrl,
});
// (config.headers["Access-Control-Allow-Credentials"] = true),
chatbotReq.interceptors.request.use((config) => {
  config.headers["x-api-key"] = securityKey;
  return config;
});

export const deloitUrl = Config.SCHEDULER_SERVICE_URL;
export const deloitReq = axios.create({
  baseURL: deloitUrl,
  withCredentials: true,
});

// Adding Accept-Language header to  deloitReq
deloitReq.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = i18next.language || "en-US";
  return config;
});

export const mulesoftUrl = Config.OKTA_USER_URL;
export const mulesoftReq = axios.create({
  baseURL: mulesoftUrl,
});

export const mulesoftUrlTwo = Config.OKTA_USER_URL_TWO;
export const mulesoftReqTwo = axios.create({
  baseURL: mulesoftUrlTwo,
});

export const oktaUrl = Config.OKTA_BASE_URL;
export const oktaReq = axios.create({
  baseURL: oktaUrl,
  withCredentials: true,
});

export const oktaOauthUrl = Config.OKTA_OAUTH_URL;
export const oktaOauthReq = axios.create({
  baseURL: oktaOauthUrl,
});

export default {
  oktaReq,
  oktaOauthReq,
  deloitReq,
  mulesoftReq,
  mulesoftReqTwo,
};
